import { FileText, Users, Heart, Shield, Landmark } from 'lucide-react';

export const ICON_MAPPING = {
  FileText,
  Users,
  Heart,
  Shield,
  Landmark,
};

export const getIcon = (iconName) => {
  return ICON_MAPPING[iconName] || FileText;
};
